import GenericDB from './generic-db';

export default class ClientFilesDB extends GenericDB {
  constructor() {
    super('clientFiles');
  }
}
